import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { CONSTANTS } from 'src/app/core/constants/constants';

@Component({
  selector: 'app-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss'],
})
export class DeleteConfirmationModalComponent {
  @Input() isGroup: boolean;
  @Input() objectName: string;
  @Input() usageCasesAmount: number;
  @Input() objectsAmount: number;
  @Input() objectsUsedBy: string = 'analysis case';
  @Output() delete = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private ngxSmartModalService: NgxSmartModalService) {}

  get toBeByAmount(): string {
    return this.objectsAmount === 1 || this.isGroup ? 'is' : 'are';
  }

  get pluralByObjectsAmount(): string {
    return this.objectsAmount === 1 || this.isGroup ? '' : 's';
  }

  get pluralByUsageAmount(): string {
    return this.usageCasesAmount === 1 ? '' : 's';
  }

  get objectsReferenceOrAmount(): string | number {
    return this.objectsAmount === 1 ? 'The' : this.objectsAmount;
  }

  get messageObjectTemplate(): string {
    return `${this.objectsReferenceOrAmount} selected ${
      this.objectName + this.pluralByObjectsAmount
    } ${this.toBeByAmount} currently being used ${this.usageCasesAmount} time${
      this.pluralByUsageAmount
    } by ${this.objectsUsedBy}s. Deleting will cause removal from respective vinculated ${
      this.objectsUsedBy
    }${this.pluralByUsageAmount}.`;
  }

  get messageGroupTemplate(): string {
    return `Delete this group along with all it's ${this.objectName}s? Deleting will cause removal form respective vinculated ${this.objectsUsedBy}s.`;
  }

  emitDeleteEvent(): void {
    this.delete.emit();
    this.close();
  }

  emitCancelEvent(): void {
    this.cancel.emit();
    this.close();
  }

  close(): void {
    this.ngxSmartModalService.getModal(CONSTANTS.MODAL_ID.DELETE_CONFIRMATION).close();
  }
}
